module.exports = __webpack_public_path__ + "img/camera.689e36f8.png";